import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { TabBar } from './components/TabBar.js'
import { History } from './screens/History.js'
import { Home } from './screens/Home.js'
import { LogActivity } from './screens/LogActivity.js'
import { Onboarding } from './screens/Onboarding.js'
import { Profile } from './screens/Profile.js'
import { SessionDone } from './screens/SessionDone.js'
import { useStore } from './store/useStore.js'

/** Écrans plein cadre : ils masquent la barre d'onglets. */
const FULLSCREEN_ROUTES = ['/log', '/done']

export function App() {
  const onboarded = useStore((s) => s.onboarded)
  const location = useLocation()
  const showTabs = onboarded && !FULLSCREEN_ROUTES.includes(location.pathname)

  return (
    // Mobile-first : sur desktop l'app reste une colonne centrée, elle ne
    // s'étale pas. C'est la décision d'architecture "pas de version desktop".
    <div className="mx-auto flex h-dvh w-full max-w-[430px] flex-col overflow-hidden">
      {onboarded ? (
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/log" element={<LogActivity />} />
          <Route path="/done" element={<SessionDone />} />
          <Route path="/history" element={<History />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      ) : (
        <Onboarding />
      )}
      {showTabs && <TabBar />}
    </div>
  )
}
